import api from "./api";

const route = "/purchases";

export default {
  getOrdenes: () => api.get(route),
  getOrden: (payment_id) => api.get(`${route}/${payment_id}`),
  postRefund: (payment_id) => api.post(`${route}/refund`, { payment_id }),
};
